<template>
    <div class="carlist_wrapper">
        <!--品牌-->
        <div class="series_wrapper" v-if="series_show">
            <div class="header_wrapper">
                <b class="left_title">选择品牌</b>
            </div>
            <div class="out_main_wrapper">
                <div class="main_wrapper_series">
                    <div class="left_firstseries" ref="left_firstseries">
                        <!--热门-->
                        <div class="hot_wrapper" v-if="hot.length>0">
                            <div class="hot_title">
                                <b>热门品牌</b>
                                <img src="../assets/image/hot.png">
                            </div>
                            <ul class="hot_list_wrapper">
                                <li v-for="(item,index) in hot" :key="index" @click="clk_brand(item)">
                                    {{item.brand_name}}
                                </li>
                            </ul>
                        </div>
                        <!--列表-->
                        <div class="series_list_wrapper" @scroll="handleScroll()" ref="series_list_wrapper">
                            <ul class="series_list">
                                <li class="series_list_item"
                                    v-for="(brand,brand_id) in brand" :key="brand_id" @click="clk_brand(brand)"
                                >
                                    {{brand.brand_name}}
                                </li>
                            </ul>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <!--车型-->
        <div class="brand_wrapper" v-if="brand_show">
            <div class="header_wrapper">
                <van-icon name="arrow-left" @click="goback"/>
                <b class="left_title">{{brand_name}}</b>
                <van-icon name="cross" @click="closePopup"/>
            </div>
            <div class="main_wrapper_brand">
                <ul>
                    <!--  brand_list-->
                    <li class="series_list_item"
                        v-for="(series, series_id) in series_list" :key="series_id"
                        @click="clk_series(brand_id, brand_name, series.series_id, series.series_name)"
                    >{{series.series_name}}
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>

    import lib_car from "@/libs/lib_car";

    export default {
        props: {
            activity_id: {type: Number, default: 0}, //项目id
            custom_car: {type: Number, default: 0}, //是否自定义车型库
            is_dialog_car: {type: Boolean, default: false}
        },

        data() {
            return {
                hot: [], //热门车型
                brand: [], //品牌
                letter: [], //右侧ABC
                series_list: [], //车型
                brand_id: undefined, //品牌id
                brand_name: '', //品牌name


                is_brand: true,
                current_brand: {},

                series_show: true,
                brand_show: false,
            };
        },
        created() {
            // todo 车型加载及两次请求， 无图片的(两个组件) 参数控制加载A/B
            // todo 单品，无弹框，下拉处理
            let that = this;
            lib_car.nosort(this.activity_id, this.custom_car, function (data) {
                console.log(data, '====')
                that.hot = data.hot;
                that.brand = data.brand;
            })
        },
        mounted() {

        },
        destroyed() {
        },
        methods: {

            // 滚动

            //选择品牌
            clk_brand(brand) {
                this.current_brand = brand;
                this.brand_id = brand.brand_id; // 品牌id
                this.brand_name = brand.brand_name;  // 品牌name
                // this.is_brand = false;
                this.series_show = false;
                this.brand_show = true;
                let that = this;
                lib_car.series(this.activity_id, this.custom_car, brand.brand_id, function (data) {
                    that.series_list = data
                })
            },

            //选择车型
            clk_series(brand_id, brand_name, series_id, series_name) {
                // this.is_brand = true;
                this.series_show = false;
                this.brand_show = false;
                this.$emit("query", brand_id, brand_name, series_id, series_name);
            },

            // others methods
            closePopup() {
                this.$emit('handleClose', false)
            },
            goback() {
                // this.is_brand = true;
                this.brand_show = false;
                this.series_show = true;
            }
        },
        watch: {
            is_dialog_car(v) {
                this.series_show = v;
                this.brand_show = false;
            },
            series_show(v) {
                if (v == false) {
                    // this.activeLetter = this.letter[0]
                }
            }
        }
    };
</script>

<style lang="less">
    @import "../assets/style/carList/carlist_noimg.less";
</style>
